import { apiClient } from 'api/apiClient';
import axios from 'axios';
import { File } from 'types';

const SERVICE_PATH = '/ps';

const getPath = (path = '', isPublic = false) => {
  return `${apiClient.getPath(SERVICE_PATH, isPublic)}${apiClient.Paths.FILES}${path}`;
};

const getUploadUrl = async (fileName: string) => {
  const res = await apiClient.apiInstance.post<{ id: string; uploadUrl: string }>(getPath('/upload/start'), {
    name: fileName,
  });
  return res.data;
};

const startUploading = async (url: string, data: ArrayBuffer, requestHeader: string) => {
  const res = await axios.put(url, data, {
    headers: { 'Content-Type': requestHeader },
  });
  return res.data;
};

const finishUploading = async (fileId: string) => {
  const res = await apiClient.apiInstance.post(getPath(`/${fileId}/upload/finish`), { fileId });
  return res.data;
};

const getFile = async (fileId: string) => {
  const res = await apiClient.apiInstance.post<File>(getPath(`/${fileId}`), { fileId });
  return res.data;
};

export const fileService = { getUploadUrl, startUploading, finishUploading, getFile };
